import { useContext } from 'react';
import DiscardChangesContext from 'common/contexts/DiscardChangesContext';

export default function useDiscardChangesContext() {
  return useContext(DiscardChangesContext);
}
